import { Paragraph } from '@fs/zion-ui'
import React, { type ComponentProps } from 'react'
import { Trans } from 'react-i18next'
import { formatDate } from '../helpers/formatDate'

type Props = {
  creationDateMs: number
} & ComponentProps<typeof Paragraph>

export default function PersonCreatedDate({ creationDateMs, ...paragraphProps }: Props): JSX.Element | null {
  return (
    <Paragraph size="sm" {...paragraphProps}>
      <Trans i18nKey="merge.added.label" values={{ personCreationDate: formatDate(creationDateMs) }} />
    </Paragraph>
  )
}
